<template>
  <div class="modal fade" :id="id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ !isEdit ? $t('contactStatus.creation') : $t('contactStatus.modification') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body scroll-y " style="max-height: 75vh;">
            <RequiredText />
            <div class="d-flex flex-column mb-8 fv-row">
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('label.name') }}</span>
              </label>
              <input type="text" v-model="formData.name" class="form-control form-control-solid"  required
                     :placeholder="$t('taxes.title_placeholder')" />
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import { ref, defineProps, watch } from "vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"

const store = useStore()
const props = defineProps({
  status: {
    type: Object,
    default: {
      name: '',
    }
  },
  id: {
    type: String,
    required: true
  },
  parentId: { type: String, required: false },
  isEdit: { type: Boolean, default: false }
})

const emits = defineEmits(["callback"])

const formData = ref(props.status)
const isLoading = ref(false)

watch(() => props.status, (value) => {
  formData.value = value
}, { deep: true })

function submitData(){
  if(!props.isEdit){
    createStatusData()
  }else{
    updateStatusData()
  }
}

function createStatusData() {

  isLoading.value = true
  store.dispatch('customerStatus/createCustomerStatus', formData.value)
      .then((response) => {
        emits('callback', response.data.status)
        isLoading.value = false
        formData.value.name = ""
        closeModal()
        window.toastr['success'](i18n.global.t('notification.contact_status_created_successfully'))
      })
      .catch(err => {
        isLoading.value = false
      })
}

function updateStatusData() {

  isLoading.value = true
  store.dispatch('customerStatus/updateCustomerStatus', formData.value)
      .then((response) => {
        emits('callback')
        isLoading.value = false
        closeModal()
        window.toastr['success'](i18n.global.t('notification.contact_status_updated_successfully'))
      })
      .catch(err => {
        isLoading.value = false
      })
}

function closeModal(){
  if(props.parentId) {
    $('#'+props.parentId).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
}
</script>

<style scoped></style>
